module.exports = __webpack_public_path__ + "static/media/store.a7901d86.png";